import React, { useState, useEffect } from "react";
import { Stage, Layer, Image } from "react-konva";
import ContextMenu from "../ContextMenu";
import Rectangle from "./Rectangle";
import Icon from "../Icon";
import { RiAddCircleLine } from "react-icons/ri";
import PopupTriggerRect from "./PopupTriggerRect";
import PopupPropertiesMenu from "../PopupPropertiesMenu/PopupPropertiesMenu";
import HeresAmericaService from "../../../../../services/HA/HeresAmericaService";
import {
  displayErrorToast,
  displaySuccessToast,
} from "../../../../../utils/toast";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import TokenService from "../../../../../services/auth/TokenService";
// REMINDER: when adding functionality that relies on a popup icon being selected,
// you must use the 'selection' variable to ensure you have the correct selection

// eslint-disable-next-line no-unused-vars
let selection = null;
let tempTrigger = null;
// eslint-disable-next-line no-unused-vars
let tempArray = null;

const PopupCanvas = ({
  background,
  stageRef,
  canvasWidth,
  canvasHeight,
  scale,
  bgRef,
  rects,
  points,
  popupTriggers: triggers,
  setPopupTriggers: setTriggers,
  pointColor,
  setListening,
  bookId,
  minScale,
  updatePopupTriggerCoords,
  handleSaveButton,
  popupTriggers,
  setHasHaQuizBeenDeleted,
}) => {
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: null,
    y: null,
  });
  const [propertiesMenu, setPropertiesMenu] = useState({
    visible: false,
    x: null, // Initial x position
    y: null, // Initial y position
  });
  const [contextMenuOptions, setContextMenuOptions] = useState([]);
  const [quizData, setQuizData] = useState(null);
  // set up the key listener for the below function
  useEffect(() => {
    if (propertiesMenu.visible) {
      document.addEventListener("keydown", handleKeyDown);
    } else if (!propertiesMenu.visible) {
      document.removeEventListener("keydown", handleKeyDown);
    }
  }, [propertiesMenu]);

  // prevent cmd + s from saving the book
  const handleKeyDown = (e) => {
    // if (e.key === "Escape") {
    //   setPropertiesMenu({ ...propertiesMenu, visible: false });
    //   setListening(true);
    // }
    if (e.key === "s" && e.metaKey) e.preventDefault();
  };

  useEffect(() => {
    if (triggers) tempArray = triggers.slice();
  }, [triggers]);

  const selectObject = (selection) => {
    tempArray = triggers.slice();
    tempTrigger = selection;

    setTriggers(
      triggers.map((t) => {
        if (t.id === selection.id)
          return {
            ...t,
            selected: true,
          };
        else return t;
      })
    );
  };

  const handleStageClick = (e) => {
    if (contextMenu.visible) {
      setListening(true);
      hideContextMenu();
      return;
    }
    deselectAll();

    // if the user right-clicks
    if (e.evt.button === 2) {
      if (e.target !== bgRef.current) selectObject(e.target);
      if (!propertiesMenu.visible) {
        generateContextOptions(e);
        showContextMenu(e);
        return;
      }
    }
  };

  const handleTriggerClick = (e, trigger) => {
    selectObject(trigger);
    showPropertiesMenu(e);
  };

  const handleClickTriggerRect = (e, trigger) => {
    hideContextMenu();
    selectObject(trigger);

    if (e.evt.button === 2) showPropertiesMenu(e);
  };

  const createTriggerAndOpenMenu = () => {
    setListening(true);
    hideContextMenu();

    const { x: xPos, y: yPos } = stageRef.current.getPointerPosition();

    const triggerToAdd = {
      x: xPos / scale.x,
      y: yPos / scale.x,
      width: 50,
      height: 50,
      id: triggers?.length || 0,
      name: "trigger",
      type: "icon",
      fill: "#00D14A",
      scale: 50,
      selected: false,
      isQuiz: false,
      title: null,
      items: [],
    };

    let temp = triggers?.slice() || [];
    temp.push(triggerToAdd);
    setTriggers(temp);
    tempTrigger = triggerToAdd;

    // open properties menu
    const { x, y } = stageRef.current.getPointerPosition();
    setListening(false);
    hideContextMenu();
    setPropertiesMenu({
      ...propertiesMenu,
      x: x,
      y: y,
      visible: true,
    });
  };

  const deselectAll = () => {
    if (triggers)
      setTriggers(
        triggers.map((trigger) => {
          return {
            ...trigger,
            selected: false,
          };
        })
      );
  };

  const updateTriggerProps = ({
    id,
    title,
    titleAudio,
    iconUrl,
    type,
    scale,
    fill,
    isQuiz,
    items,
    quizDetails,
    quizType,
    onPageShortAnswerDetails,
    languageSelectionMenu,
  }) => {
    setTriggers(
      triggers.map((trigger) => {
        if (trigger.id === id) {
          return {
            ...trigger,
            title,
            titleAudio,
            iconUrl,
            type,
            scale,
            fill,
            isQuiz,
            languageSelectionMenu,
            onPageShortAnswerDetails,
            ...(isQuiz ? { items: [] } : { items }), // if it's saved as a quiz, clean up any items that were created
            ...(isQuiz ? { quizDetails } : { quizDetails: {} }),
            quizType,
          };
        } else return trigger;
      })
    );
  };

  function updateTriggerDisplay(trigger, { scale, url }) {
    setTriggers(
      triggers.map((t) => {
        if (t.id === trigger.id) {
          return {
            ...t,
            ...(scale && { scale: scale }),
            iconUrl: url,
          };
        } else return t;
      })
    );
  }

  // const deleteObject = () => {
  //   setPropertiesMenu({ ...propertiesMenu, visible: false });
  //   setListening(true);
  //   hideContextMenu();
  //   let temp = [...triggers];
  //   temp.splice(tempTrigger.id, 1);
  //   temp.forEach((trigger, i) => {
  //     trigger.id = i;
  //   });
  //   setTriggers(temp);
  // };
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [quizIdToDelete, setQuizIdToDelete] = useState(null);

  const handleConfirmationModalConfirm = async () => {
    setShowConfirmationModal(false);
    await deleteTrigger();
  };

  const handleConfirmationModalCancel = () => {
    setShowConfirmationModal(false);
  };

  const deleteObject = async (event) => {
    if (tempTrigger && tempTrigger.haQuizId) {
      setQuizIdToDelete(tempTrigger.haQuizId);
      setShowConfirmationModal(true);
      return;
    } else {
      // Proceed with deleting the trigger
      await deleteTrigger(event);
    }
  };
  const deleteTrigger = async (event) => {
    try {
      // Make an API call to delete the quiz
      if (quizIdToDelete) {
        await HeresAmericaService.deleteQuizById(bookId, quizIdToDelete);
        displaySuccessToast(`Quiz id ${quizIdToDelete} deleted successfully`);
        setHasHaQuizBeenDeleted(true);
      }

      setPropertiesMenu({ ...propertiesMenu, visible: false });
      setListening(true);
      hideContextMenu();

      let temp = [...triggers];
      temp.splice(tempTrigger.id, 1);
      temp.forEach((trigger, i) => {
        trigger.id = i;
      });
      console.log("temp", temp);

      setTriggers(temp);
    } catch (error) {
      console.error("Failed to delete quiz", error);
      displayErrorToast(`Failed to delete quiz id ${quizIdToDelete}`);
      // Handle error (e.g., show a message to the user)
      return; // Stop the function if the API call fails
    } finally {
      if (quizIdToDelete) {
        //after deleting the quiz , pass the id to the parent component to update the json in s3
        // handleSaveButton(event);
      }
      setQuizIdToDelete(null);
    }
  };
  const generateContextOptions = (e) => {
    if (e.target === stageRef.current || e.target === bgRef.current) {
      setContextMenuOptions([
        {
          name: "New popup",
          icon: <RiAddCircleLine size={20} />,
          func: createTriggerAndOpenMenu,
        },
      ]);
    }
  };

  const showContextMenu = (e) => {
    const { x, y } = stageRef.current.getPointerPosition();
    e.evt.preventDefault();
    setListening(false);
    setContextMenu({
      ...contextMenu,
      x: x,
      y: y,
      visible: true,
    });
  };

  const showPropertiesMenu = (e) => {
    e.evt.preventDefault();
    const { x, y } = stageRef.current.getPointerPosition();
    setListening(false);
    hideContextMenu();
    setPropertiesMenu({
      ...propertiesMenu,
      x: x,
      y: y,
      visible: true,
    });
  };

  const hideContextMenu = () => {
    setContextMenu({
      ...contextMenu,
      visible: false,
    });
  };

  const updateSize = (id, { x, y, width, height }) => {
    setTriggers(
      triggers.map((trigger) => {
        if (trigger.id === id) {
          return {
            ...trigger,
            x,
            y,
            width,
            height,
          };
        } else return trigger;
      })
    );
  };

  const getObjectById = (id) => {
    return triggers.find((item) => {
      return item.id === parseInt(id);
    });
  };

  function handleMouseDown(trigger) {
    // deselect all except this trigger
    setTriggers(
      triggers.map((t) => {
        if (trigger.id === t.id)
          return {
            ...t,
            selected: true,
          };
        else
          return {
            ...t,
            selected: false,
          };
      })
    );
  }

  const handleDragMove = (e) => {
    const obj = getObjectById(e.target.attrs.id);
    const movement = {
      x: e.target.x() - obj.x,
      y: e.target.y() - obj.y,
    };

    setTriggers(
      triggers.map((trigger) => {
        if (trigger.selected) {
          return {
            ...trigger,
            x: trigger.x + movement.x,
            y: trigger.y + movement.y,
          };
        } else return trigger;
      })
    );
  };
  async function getQuizFromHaQuizId(bookId, haQuizId) {
    try {
      const res = await HeresAmericaService.getQuizById(bookId, haQuizId);
      console.log(res);
      setQuizData(res);
      console.log("🚀 ~ getQuizFromHaQuizId ~ res:", res);
    } catch (error) {
      displayErrorToast(error.message);
      console.error(error);
    }
  }
  useEffect(() => {
    console.log("properties menu", propertiesMenu.visible);
    if (!propertiesMenu.visible) {
      setQuizData(null);
      console.log("properties menu is visible");
    }
  }, [propertiesMenu]);

  useEffect(() => {
    console.log({ bookId });
  }, [bookId]);
  return (
    <div className="canvas">
      <Stage
        scale={scale}
        ref={stageRef}
        width={canvasWidth}
        height={canvasHeight}
        onClick={handleStageClick}
      >
        <Layer>
          <Image image={background} ref={bgRef} />
        </Layer>
        <Layer>
          {rects &&
            rects.map((rect, index) => {
              return (
                <Rectangle
                  key={index}
                  index={index}
                  id={String(index)}
                  x={rect.x}
                  y={rect.y}
                  width={rect.width}
                  height={rect.height}
                  draggable={false}
                  fill="#b3b3b350"
                  stroke="gray"
                  strokeWidth={1}
                  dash={[4, 3]}
                  rect={rect}
                />
              );
            })}
        </Layer>
        <Layer>
          {points &&
            points.map((point) => {
              return (
                <Icon
                  id={String(point.id)}
                  key={point.id}
                  x={point.x}
                  y={point.y}
                  iconUrl={point.iconUrl}
                  symbol={point.icon || "?"}
                  color={point.color}
                  listening={false}
                  scale={point.scale}
                  canvasWidth={canvasWidth}
                  canvasHeight={canvasHeight}
                  canvasScale={scale}
                  disabled
                />
              );
            })}
        </Layer>
        <Layer>
          {triggers &&
            triggers.map((trigger, index) => {
              if (trigger.type === "rect") {
                return (
                  <PopupTriggerRect
                    key={index}
                    id={String(trigger.id)}
                    x={trigger.x}
                    y={trigger.y}
                    width={trigger.width}
                    height={trigger.height}
                    handleClick={(e) => {
                      e.cancelBubble = true;
                      handleClickTriggerRect(e, trigger);
                      if (trigger.haQuizId) {
                        // console.log("trigger has quiz id" + trigger.haQuizId);
                        getQuizFromHaQuizId(bookId, trigger.haQuizId);
                      }
                    }}
                    selected={trigger.selected}
                    updateSize={updateSize}
                    trigger={trigger}
                    handleMouseDown={() => handleMouseDown(trigger)}
                    handleDragMove={handleDragMove}
                    triggers={triggers}
                    setTriggers={setTriggers}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    draggable
                    minScale={minScale}
                  />
                );
              } else {
                return (
                  <Icon
                    id={trigger.id}
                    key={trigger.id}
                    x={trigger.x}
                    y={trigger.y}
                    iconUrl={trigger.iconUrl}
                    symbol={trigger.icon || "?"}
                    color={trigger.color}
                    listening
                    draggable
                    scale={trigger.scale}
                    canvasWidth={canvasWidth}
                    canvasHeight={canvasHeight}
                    canvasScale={scale}
                    onClick={(e) => {
                      e.cancelBubble = true;
                      handleTriggerClick(e, trigger);
                      if (trigger.haQuizId) {
                        console.log("trigger has quiz id" + trigger.haQuizId);
                        getQuizFromHaQuizId(bookId, trigger.haQuizId);
                      }
                    }}
                    updatePointCoords={updatePopupTriggerCoords}
                  />
                );
              }
            })}

          {contextMenu.visible && (
            <ContextMenu
              id="contextMenu"
              x={contextMenu.x}
              y={contextMenu.y}
              options={contextMenuOptions}
            />
          )}
        </Layer>
      </Stage>
      {propertiesMenu.visible && tempTrigger && (
        <PopupPropertiesMenu
          bookId={bookId}
          handleSaveButton={handleSaveButton}
          quizData={quizData}
          id="propertiesMenu"
          x={propertiesMenu.x}
          y={propertiesMenu.y}
          triggers={triggers}
          setTriggers={setTriggers}
          target={tempTrigger}
          color={pointColor}
          propertiesMenu={propertiesMenu}
          setPropertiesMenu={setPropertiesMenu}
          setListening={setListening}
          updateTriggerProps={updateTriggerProps}
          deleteObject={deleteObject}
          updateTriggerDisplay={updateTriggerDisplay}
        />
      )}

      <Dialog
        open={showConfirmationModal}
        onClose={handleConfirmationModalCancel}
      >
        <DialogTitle>Delete Quiz</DialogTitle>
        <DialogContent>
          <p>
            Are you sure you want to delete the quiz with id {quizIdToDelete}{" "}
            from Heres America? Confirming this action will delete the quiz and
            automatically save and update any json on the current page.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmationModalCancel} color="error">
            Cancel
          </Button>
          <Button onClick={handleConfirmationModalConfirm} color="info">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PopupCanvas;
